<template>
  <div class="container" v-if="loaded">
    <van-cell-group>
      <van-cell v-for="(item, index) in userBonusLogs" :key="index">
        <template slot="icon">
          <img class="avatar" :src="item.inviteUser ? item.inviteUser.avatar : user.avatar" alt="">
        </template>
        <template slot="title">
          <p class="title" v-if="item.types === 'withdraw'">提现成功</p>
          <p class="title" v-if="item.types !== 'withdraw'">{{item.inviteUser.nickname}}</p>
          <p class="desc" v-if="item.types !== 'withdraw'">购买课程《{{item.subject.title}}》</p>
        </template>
        <p class="desc">{{$moment(item.createdAt).format('YY-MM-DD')}}</p>
        <p class="price" :class="item.types === 'withdraw' ? 'minus' : 'plus'">{{item.types === 'withdraw' ? '-' : '+'}} {{item.amount}}</p>
      </van-cell>
    </van-cell-group>
    <Empty :show="userBonusLogs.length === 0" text="暂无历史明细" />
  </div>
</template>
<script>
import { getBonusLogs } from './query.gql'
import Empty from '@/components/Empty'
export default {
  name: 'history',
  data() {
    return {
      userBonusLogs: [],
      loaded: false,
      user: ''
    }
  },
  components: {
    Empty
  },
  async mounted() {
    await this.weixinAuth()
    this.loadData()
  },
  methods: {
    loadData() {
      const self = this
      self.loaded = false
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getBonusLogs,
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.userBonusLogs = res.data.userBonusLogs
        self.user = res.data.profile
        self.loaded = true
        self.$toast.clear()
      }).catch(err => {
        console.error('page：distributor/index。请求getDistributorInfo报错', err)
        self.$toast.clear()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .container{
    .van-cell{
      padding: 15px;
      &:after{
        left: 65px;
      }
      .avatar{
        width: 40px;
        height: 40px;
        border-radius: 20px;
        display: block;
        margin-right: 10px;
      }
      .van-cell__title{
        .title{
          color: #333;
          font-size: 14px;
          line-height: 20px;
        }
        .desc{
          color: #999;
          font-size: 12px;
          padding-top: 4px;
          line-height: 16px;
        }
      }
      .van-cell__value{
        flex: none;
        .desc{
          color: #999;
          font-size: 12px;
          line-height: 16px;
        }
        .price{
          font-weight: bold;
          font-size: 14px;
          line-height: 20px;
          padding-top: 4px;
          &.plus{
            color: #EB5729;
          }
          &.minus{
            color: #2F9EFE;
          }
        }
      }
    }
  }
</style>
